export default {
  state: {
    accessToken: null,
    profilePhoto: undefined,
    first_name: null,
    last_name: null,
    username: null,
    email: null,
    groups: [],
    avatar: null,
    is_staff: false,
    is_client_admin: false,
    can_view_profiles: false,
    can_add_profiles: false,
    can_delete_profiles: false,
    can_change_profiles: false,
    user_id: null,
  },
  mutations: {
    setProfilePhoto(state, {file}) {
      state.profilePhoto = file;
    },
    setUserGroups(state, groups) {
      state.groups = Object.fromEntries(groups.map(x => [x.name, true]))
    },
    setUserInfo(state, {first_name, last_name, username, email}) {
      state.first_name = first_name || null;
      state.last_name = last_name || null;
      state.username = email || null;
      state.email = email || null;
    },
    setUserPermissions (state, permissionsArray) {
      const decoded = Object.fromEntries(permissionsArray.map(x => [x.codename, true]))
      console.log("WARNING client_admin and is_staff permissions are not set by the current version of the portal.")
      state.is_staff = decoded.is_staff || false;
      state.is_client_admin = decoded.is_client_admin || true;
      state.can_view_profiles = decoded.view_profile_definition || false;
      state.can_add_profiles = decoded.add_profile_definition || false;
      state.can_delete_profiles = decoded.delete_profile_definition || false;
      state.can_change_profiles = decoded.change_profile_definition || false;
      state.user_id = decoded.user_id || null;
    },
  },
  actions: {
    async logIn (context, payload) {
      let success;

      await context.rootState.inst.post('/api/auth/google/', payload)
      .then((response) => {
        context.commit('setAccessToken', response.data.access_token);
        context.commit('setUserPermissions', response.data.user.user_permissions);
        context.commit('setUserInfo', response.data.user);
        context.commit('setUserGroups', response.data.user.groups)
        success = true;
      })
      .catch(() => {
        success = false;
      });

      return success;
    },
    logOut (context) {
      context.commit('resetAccessToken');
      context.commit('setUserPermissions', []);
      context.commit('setUserInfo', {});
    },
  }
}